import React, { useState, useEffect } from "react";
import axios from "axios";
import { exportSaleData } from "./exportSaleData";
import progressGif from "../../images/progress.gif";
const Sales_nfsa_Non_Nfsa_Data = ({
  nfsaType,
  distMonth,
  distYear,
  transMonth,
  transYear,
  fetchTrigger,
}) => {
  const [commodities, setCommodities] = useState([]);
  const [commCodes, setCommCodes] = useState([]);
  const [monthWiseData, setMonthWiseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [refreshTime, setRefreshTime] = useState("");

  const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString("default", { month: "long" });
  };

  const formatDate = (isoDateStr) => {
    if (!isoDateStr) return "";
    const date = new Date(isoDateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  useEffect(() => {
    if (!fetchTrigger) return;

    const fetchData = async () => {
      setLoading(true);
      setError("");
      setCommodities([]);
      setCommCodes([]);
      setMonthWiseData([]);

      try {
        const commRes = await axios.get(
          `${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/commodities/list`,
          {
            params: { nfsaType, month: distMonth, year: distYear },
          }
        );
        setCommodities(commRes.data);
        const codes = commRes.data.map((c) => c.commId.toString());
        setCommCodes(codes);

        const monthRes = await axios.post(
          `${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/distMonthYear`,
          codes,
          {
            params: { nfsaType, distMonth, distYear, transMonth, transYear },
          }
        );

        setMonthWiseData(monthRes.data);
        setRefreshTime(
          new Date().toISOString().replace("T", " ").split(".")[0]
        );
      } catch (err) {
        console.error(err);
        setError("No Data Found.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fetchTrigger, nfsaType, distMonth, distYear, transMonth, transYear]);

  const totals = {};
  commCodes.forEach((code) => {
    totals[code] = monthWiseData.reduce(
      (sum, row) => sum + (row.dynamicFields?.[`comm_code_${code}`] || 0),
      0
    );
  });

  if (loading)
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={progressGif} alt="Loading..." width="250" height="15" />
      </div>
    );

  if (error)
    return (
      <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
        {error}
      </p>
    );

  if (commodities.length === 0)
    return (
      <p style={{ color: "red", textAlign: "center", fontWeight: "bold", textDecoration: "underline" }}>
        No Data Found
      </p>
    );

  return (
    <div
      style={{
        width: "60%",
        margin: "0 auto",
        marginTop: "20px",
        marginBottom: "200px",
      }}
    >
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr className="tableheader">
            <th
              colSpan={commCodes.length + 2}
              style={{ padding: "6px", fontSize: "14px", textAlign: "center" }}
            >
              {nfsaType === "N" ? "NFSA" : "Non-NFSA"} Date wise sale for
              Allotted Month/Year{" "}
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {getMonthName(distMonth)}
              </span>{" "}
              <span style={{ color: "white", fontWeight: "bold" }}>'</span>{" "}
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {distYear}
              </span>{" "}
              and Distributed Month/Year{" "}
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {getMonthName(transMonth)}
              </span>{" "}
              <span style={{ color: "white", fontWeight: "bold" }}>and</span>{" "}
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {transYear}
              </span>{" "}
              (in MTs)
            </th>
          </tr>
          <tr
            className="tableheader"
          >
            <th style={{ padding: "4px" }}>S.No</th>
            <th style={{ padding: "4px" }}>
              Distribution
              <br /> Date
            </th>
            {commCodes.map((code) => {
              const comm = commodities.find(
                (c) => c.commId.toString() === code
              );
              return (
                <th key={code} style={{ padding: "4px" }}>
                  {comm?.commName ?? code}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {monthWiseData.map((row, idx) => (
            <tr key={idx}>

              <td>{idx + 1}</td>
              <td>{formatDate(row.loginDateTime)}</td>
              {commCodes.map((code) => (
                <td key={code}>

                  {((row.dynamicFields?.[`comm_code_${code}`] ?? 0) / 1000).toFixed(3)}

                </td>

              ))}

            </tr>

          ))}

          <tr className="tableheader">

            <td colSpan={2}>Total</td>

            {commCodes.map((code) => (

              <td key={code}>{((totals[code] ?? 0) / 1000).toFixed(3)}</td>

            ))}

          </tr>

          <tr>
            <td colSpan={commCodes.length + 2} style={{ textAlign: "right", paddingRight: "10px" }}>
              <span style={{ color: "red", fontWeight: "bold" }}>Refresh Time : </span>
              <span style={{ color: "green" }}>{refreshTime}</span>
            </td>
          </tr>
        </tbody>

      </table>

      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          marginBottom: "30px",
        }}
      >
        <button
          onClick={() =>
            exportSaleData({
              nfsaType,
              distMonth,
              distYear,
              transMonth,
              transYear,
              commodities,
              commCodes,
              summaryData: monthWiseData,
              totals,
              refreshTime,
            })
          }
          style={{
            padding: "6px 15px",
            borderRadius: "10px",
            border: "none",
            backgroundColor: "black",
            color: "white",
            cursor: "pointer",
          }}
        >
          Data to Excel
        </button>
      </div>
    </div>
  );
};

export default Sales_nfsa_Non_Nfsa_Data;
